// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `drag-item .drag-item {
  position: absolute;
  color: black;
  width: 50px;
  height: 50px;
  margin: 0px;
  z-index: 1;
  cursor: move;
  border-radius: 100%;
  padding: 5px;
}
drag-item .drag-item img {
  width: 100%;
  height: auto;
}
drag-item .drag-item svg-icon {
  font-size: 50px;
  color: rgb(68, 68, 68);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/drag-item/drag-item.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAAR;AAGQ;EACI,WAAA;EACA,YAAA;AADZ;AAGQ;EACI,eAAA;EACA,sBAAA;AADZ","sourcesContent":["drag-item {\n    .drag-item {\n        position: absolute;\n        color: black;\n        width: 50px;\n        height: 50px;\n        margin: 0px;\n        z-index: 1;\n        cursor: move;\n        border-radius: 100%;\n        padding: 5px;\n        // border: 1px solid rgba(63, 63, 63, 0.5);\n\n        img {\n            width: 100%;\n            height: auto;\n        }\n        svg-icon  {\n            font-size: 50px;\n            color: rgb(68, 68, 68);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
